import { Action } from '../../actions';
import { CHANGE_PRIORITY_VALUE } from '../../actions/internalGroups/changePriorityValue';
import { DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS } from '../../actions/internalGroups/dropInternalGroupsFieldValidationErrors';
import { SAVE_INTERNAL_GROUPS } from '../../actions/internalGroups/saveInternalGroups';
import { EditGroupsState } from '../../typings/groupsEditState';
import { State } from '../../typings/state';
import { EditGroupsInitialState } from '../groupsEdit';

import { changePriorityValue } from './changePriorityValue';
import { dropInternalGroupsFieldValidationErrors } from './dropInternalGroupsFieldValidationErrors';
import { saveInternalGroups } from './saveInternalGroups';

export const internalGroups = (
    state: EditGroupsState = EditGroupsInitialState,
    action: Action,
    fullState: State
): EditGroupsState => {
    switch (action.type) {
        case CHANGE_PRIORITY_VALUE:
            return changePriorityValue(state, action);

        case DROP_INTERNAL_GROUPS_FIELD_VALIDATION_ERRORS:
            return dropInternalGroupsFieldValidationErrors(state, action);

        case SAVE_INTERNAL_GROUPS:
            return saveInternalGroups(state, action);

        default:
            return state;
    }
};
